<template>
  <div class="base-item shadow d-flex justify-space-between">
    <router-link
      class="fill"
      :to="{ name: 'editor-view', params: { id: item.id } }"
      @click.stop.prevent="$router.replace({ query: { preview: item.id, type: 'document' } })"
    >
      <v-btn
        color="white"
        variant="flat"
        size="x-large"
        class="base-item-label d-flex align-center justify-start"
      >
        <span>{{ item.name }}</span>
        <slot
          name="itemBadge"
          v-bind="{ item }"
        />
      </v-btn>
    </router-link>

    <div
      v-if="item.id !== showItemProgressId"
      class="base-item-options d-flex align-center justify-center "
    >
      <MenuList
        v-if="menuItems"
        :menu-items="menuItems"
        :item="item"
        v-bind="$attrs"
      />
    </div>
  </div>
</template>

<script>

import MenuList from './MenuList.vue';

export default {
  name: 'RouterListItem',
  components: {
    MenuList,
  },
  props: {
    item: { type: Object, default: () => {} },
    menuItems: { type: Array, default: () => [] },
    showItemProgressId: { type: Number, default: null },
  },
};
</script>

<style scoped lang="less">
  .v-btn {
    text-transform: none !important;
    width: 100%;

    :deep(.v-btn__content) {
      width: 100%;
    }
  }
  .v-btn:hover {
    background-color: @bg-canvas !important;
  }
  :deep(.v-btn__overlay), :deep(.v-btn__underlay) {
    background: none;
  }
  .base-item {
    width: 100%;
    height: 68px;
    background-color: white;
    margin-bottom: 2px;
  }
  .fill {
    width: 100%;
  }
  .base-item-label {
    height: 100%!important;
    width: 100%;
    border-radius: 0;
  }
  .base-item-options {
    position: relative;
    height: 100%;
    width: 40px;
  }
  .base-list-item::before {
    background-color: @text-brand;
  }
</style>
